import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { supabase } from './supabase/client';
import { toast } from 'sonner';

export function useDeepLink() {
    useEffect(() => {
        let listenerHandle: any = null;

        // Initialize listener
        const initListener = async () => {
            // Handle deep links when app is already open
            listenerHandle = await App.addListener('appUrlOpen', async (event) => {
                console.log('🔗 Deep link received:', event.url);

                try {
                    const url = new URL(event.url);

                    // 1. OAuth Deep Link (Google Login)
                    if (url.protocol === 'com.amigosecreto.app:' && url.host === 'google-auth') {
                        console.log('🔐 OAuth deep link detected');

                        const { data, error } = await supabase.auth.getSession();

                        if (data.session) {
                            console.log('✅ Session already exists');
                            window.location.href = '/';
                        } else {
                            // Try to extract tokens from hash
                            const params = new URLSearchParams(url.hash.substring(1));
                            const accessToken = params.get('access_token');
                            const refreshToken = params.get('refresh_token');

                            if (accessToken && refreshToken) {
                                await supabase.auth.setSession({
                                    access_token: accessToken,
                                    refresh_token: refreshToken,
                                });
                                console.log('✅ Session established from tokens');
                                window.location.href = '/';
                            }
                        }
                    }

                    // 2. Group Join Deep Link
                    // Firebase: https://mysterygift.page.link/join?group=ABC123
                    // Direct: https://mysterygift.app/join?group=ABC123
                    // Custom: com.amigosecreto.app://join?group=ABC123
                    else {
                        const groupId = url.searchParams.get('group');

                        if (groupId) {
                            console.log('✅ Group ID extracted from deep link:', groupId);
                            toast.success('Link do grupo detectado!');

                            // Store group ID in localStorage to be picked up by JoinGroup component
                            localStorage.setItem('pendingGroupId', groupId);

                            // Navigate to join view
                            window.dispatchEvent(new CustomEvent('navigate-to-join', {
                                detail: { groupId }
                            }));
                        }
                    }
                } catch (error) {
                    console.error('❌ Error parsing deep link:', error);
                }
            });
        };

        // Handle deferred deep links (app opened from install)
        const checkLaunchUrl = async () => {
            try {
                const result = await App.getLaunchUrl();

                if (result?.url) {
                    console.log('🚀 App launched with URL:', result.url);

                    const url = new URL(result.url);
                    const groupId = url.searchParams.get('group');

                    if (groupId) {
                        console.log('✅ Deferred group ID extracted:', groupId);
                        toast.success('Abrindo grupo automaticamente...');

                        localStorage.setItem('pendingGroupId', groupId);

                        window.dispatchEvent(new CustomEvent('navigate-to-join', {
                            detail: { groupId }
                        }));
                    }
                }
            } catch (error) {
                console.error('❌ Error checking launch URL:', error);
            }
        };

        initListener();
        checkLaunchUrl();

        // Cleanup
        return () => {
            if (listenerHandle) {
                listenerHandle.remove();
            }
        };
    }, []);
}
